import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../../lib/supabase'

export default function WelfarePreview({ isPaid }) {
  const [campaign, setCampaign] = useState(null)

  useEffect(() => {
    const fetchCampaign = async () => {
      const { data } = await supabase
        .from('welfare_campaigns').select('*').eq('status', 'active')
        .order('created_at', { ascending: false }).limit(1).single()
      if (data) setCampaign(data)
    }
    fetchCampaign()
  }, [])

  const percentage = campaign
    ? Math.min(Math.round((campaign.raised_amount / campaign.target_amount) * 100), 100)
    : 0

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">
        Active Welfare Campaign
      </div>
      {campaign ? (
        <div>
          <h3 className="font-bold text-gray-900 dark:text-white text-base mb-4 leading-snug">
            {campaign.title}
          </h3>
          <div className="bg-gray-200 dark:bg-white/10 h-2 mb-3">
            <div className="bg-green-500 h-2 transition-all" style={{ width: `${percentage}%` }} />
          </div>
          <div className="flex justify-between text-sm mb-1">
            <span className="text-green-600 dark:text-green-400 font-bold">
              ZMW {campaign.raised_amount.toLocaleString()} raised
            </span>
            <span className="text-gray-500">
              of ZMW {campaign.target_amount.toLocaleString()}
            </span>
          </div>
          <div className="text-gray-400 text-xs mt-1">{percentage}% funded</div>

          {!isPaid && (
            <div className="mt-4 flex items-center gap-2 text-xs text-gray-400 bg-gray-200 dark:bg-white/5 px-3 py-2">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <span>Activate your membership to donate</span>
            </div>
          )}
        </div>
      ) : (
        <div className="text-gray-400 text-sm text-center py-8">No active campaigns</div>
      )}
      <Link
        to="/welfare"
        className="block text-center border border-gray-200 dark:border-white/10 hover:border-green-600 text-gray-500 dark:text-gray-400 hover:text-green-600 dark:hover:text-white py-3 text-xs font-bold uppercase tracking-widest transition-colors mt-6"
      >
        View All Campaigns
      </Link>
    </div>
  )
}